"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldSubForm = exports.ModelMutatorSubForm = void 0;
const core_api_1 = require("@ikegps/core-api");
const id_1 = require("../../../id");
const collection_base_1 = require("../collection.base");
const collection_field_1 = require("../collection.field");
class ModelMutatorSubForm extends collection_field_1.ModelMutator {
    /**
     * Create a new subForm instance
     * @param id (Optional) instanceId
     * @returns the instanceId of the instance created.
     */
    create(id) {
        if (!id) {
            id = id_1.IkeId.generate(10);
        }
        const instanceIds = this.getStateValue();
        if (instanceIds.indexOf(id) !== -1) {
            throw new Error(`Subform instance id must be unique: ${id}`);
        }
        instanceIds.push(id);
        this.state.setFieldValue(this.field.id, instanceIds);
        return id;
    }
    clear() {
        for (const instance of this.field.value) {
            this.clearInstance(instance);
        }
        this.state.setFieldValue(this.field.id, null);
    }
    remove(instanceId) {
        const instanceIds = this.getStateValue();
        const index = instanceIds.indexOf(instanceId);
        if (index === -1) {
            throw new Error(`Cannot remove subform. Instance "${instanceId}" is missing from subform "${this.field.id}"`);
        }
        this.clearInstance(this.field.value[index]);
        instanceIds.splice(index, 1);
        delete this.field.instances[instanceId];
        this.field.collection.state.setFieldValue(this.field.id, instanceIds);
    }
    getStateValue() {
        const stateValue = this.field.stateValue;
        if (Array.isArray(stateValue)) {
            return stateValue.slice();
        }
        return [];
    }
    clearInstance(instance) {
        for (const fieldSchema of instance.schema.fields) {
            if (instance.hasField(fieldSchema.id)) {
                instance.getField(fieldSchema.id).Mutator.clear();
            }
        }
    }
    /**
     * Copies all subform instances from the target into this subform.
     *
     * @param from Subform to copy from.
     */
    copy(from) {
        let hasCopied = true;
        for (const instance of from.value) {
            const createdInstanceId = this.create();
            const newInstance = this.field.getInstance(createdInstanceId);
            const fieldCopied = this.copyFields(instance, newInstance);
            if (!fieldCopied) {
                hasCopied = false;
            }
        }
        return hasCopied;
    }
    /**
     * Copies a specific subform instance from the target into this subform.
     *
     * @param from Subform to copy from.
     * @param instanceId Specific instance to copy.
     */
    copyFromInstance(fromInstance) {
        const newInstanceId = this.create();
        const newInstance = this.field.getInstance(newInstanceId);
        const hasCopied = this.copyFields(fromInstance, newInstance);
        return hasCopied ? newInstance : null;
    }
    copyFields(from, to) {
        let hasCopied = true;
        for (const schemaField of from.schema.fields) {
            const field = from.getField(schemaField.id);
            const newField = to.getField(schemaField.id);
            const fieldCopied = newField.Mutator.copy(field);
            if (!fieldCopied) {
                hasCopied = false;
            }
        }
        return hasCopied;
    }
}
exports.ModelMutatorSubForm = ModelMutatorSubForm;
class CollectionModelFieldSubForm extends collection_field_1.CollectionModelField {
    constructor() {
        super(...arguments);
        this.instances = {};
        this._Mutator = null;
    }
    static isSubFormField(f) {
        return f.schema.type === CollectionModelFieldSubForm.TYPE;
    }
    get Mutator() {
        if (this._Mutator == null) {
            this._Mutator = new ModelMutatorSubForm(this);
        }
        return this._Mutator;
    }
    get value() {
        const stateValue = this.stateValue;
        if (!Array.isArray(stateValue)) {
            return [];
        }
        const output = [];
        for (const instanceId of stateValue) {
            output.push(this.getOrCreateInstance(instanceId));
        }
        return output;
    }
    getOrCreateInstance(instanceId) {
        let existing = this.instances[instanceId];
        if (existing == null) {
            existing = this.instances[instanceId] = new collection_base_1.CollectionModelFieldSubFormInstance(this, instanceId, this.schema);
        }
        return existing;
    }
    getInstance(instanceId) {
        const stateValue = this.stateValue;
        if (!Array.isArray(stateValue)) {
            return null;
        }
        const hasInstance = stateValue.indexOf(instanceId) > -1;
        if (hasInstance) {
            return this.getOrCreateInstance(instanceId);
        }
        return null;
    }
    mustGetInstance(instanceId) {
        const instance = this.getInstance(instanceId);
        if (!instance) {
            throw new Error(`mustGetInstance: failed to get instance with id ${instanceId}`);
        }
        return instance;
    }
    hasValue() {
        const stateValue = this.stateValue;
        if (!Array.isArray(stateValue)) {
            return false;
        }
        return this.stateValue.length > 0;
    }
}
exports.CollectionModelFieldSubForm = CollectionModelFieldSubForm;
CollectionModelFieldSubForm.TYPE = core_api_1.IkeFieldType.FORM;
//# sourceMappingURL=form.field.js.map